import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ClientLogin from './ClientLogin';
import ViewTicket from './ViewTicket';
import { UpgradeModalProvider } from '../../context/UpgradeModalContext';

const Index = () => {
    return (
        <UpgradeModalProvider>
            <Routes>
                <Route path="/" element={<ClientLogin />} />
                <Route path="/:uuid" element={<ViewTicket />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </UpgradeModalProvider>
    );
};

export default Index;
